import React from "react";
import { Navigate } from "react-router-dom";

/** Legacy routes redirect into the new marketing IA. */
export default function ValuesPage() {
  return <Navigate to="/#about" replace />;
}
